import app from '../app.first';
import Highcharts from 'highcharts';
require('highcharts/highcharts-more')(Highcharts);

app.GenericChart = class extends app.Component {
	onReady () {
		this.performanceChart = Highcharts.chart(this.el, this.$el.data('graphOptions'));
	}
}
